var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3"},[_c('div',{staticClass:"d-flex flex-wrap"},_vm._l((_vm.activityArr),function(item){return _c('div',{key:item.cn,staticClass:"d-center-start w-50 mb-3"},[_c('left-text',{attrs:{"leftText":item.cn}}),_vm._v(_vm._s(item.value)+"\n    ")],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }